
export default {
  title: '¡Operación Exitosa!',
  get_more_tokens: 'Adquirir más OCC Tokens',
  or: 'Ó',
  go_to_evaluations_list: 'Ir al Listado de valoraciones',
  information: 'Si desea adquirir más OCC Tokens diríjase a Operaciones de Suite'
}
